import { deleteRequest, getRequest, postRequest, putRequest } from './api';

const mediaPlanningApi = {
  // month = 'YYYY-MM'. Returns the planning grid: brand-level days[] with the
  // budgeted / should-spend / real layers + platforms[] with campaigns and
  // their budget overrides.
  async getMediaPlanning(brandId, month) {
    const res = await getRequest(`/api/media-planning/${brandId}?month=${month}`);
    return res?.data ?? res;
  },

  // payload = { platform, campaign_id, from_date, to_date, amount, source, name }
  async createOverride(brandId, payload) {
    const res = await postRequest(`/api/media-planning/${brandId}/overrides`, payload);
    return res?.data ?? res;
  },

  async deleteOverride(brandId, overrideId) {
    return deleteRequest(`/api/media-planning/${brandId}/overrides/${overrideId}`);
  },

  // Dry-run diff of what the plan would push to the platform for a date.
  async getApplyPreview(brandId, date) {
    const res = await getRequest(`/api/media-planning/${brandId}/apply-preview?date=${date}`);
    return res?.data ?? res;
  },

  async applyPlan(brandId, date, dryRun = false) {
    const res = await postRequest(`/api/media-planning/${brandId}/apply`, {
      date,
      dry_run: dryRun,
    });
    return res?.data ?? res;
  },

  // payload = { month: 'YYYY-MM', marketing_pct: 0.1, rest_of_year: bool }
  async setPlan(brandId, payload) {
    const res = await putRequest(`/api/media-planning/${brandId}/plan`, payload);
    return res?.data ?? res;
  },

  // payload = { name, from_date, to_date } — an informational promo marker.
  async createPromo(brandId, payload) {
    const res = await postRequest(`/api/media-planning/${brandId}/promos`, payload);
    return res?.data ?? res;
  },

  async deletePromo(brandId, promoId) {
    return deleteRequest(`/api/media-planning/${brandId}/promos/${promoId}`);
  },

  // Cross-brand promo calendar for a month: { days, global_promos, brands[] }.
  async getPromoCalendar(month) {
    const res = await getRequest(`/api/media-planning/calendar?month=${month}`);
    return res?.data ?? res;
  },
};

export default mediaPlanningApi;
